import styled, { css } from 'styled-components';

export const AnimatedContainer = styled.div`
  max-height: 0;
  opacity: 0;
  overflow: hidden;

  ${props =>
    css`
      transition: all ${props.duration}s ease-out,
        opacity ${props.duration / 2}s;
    `};

  ${props =>
    props.show
    && css`
      max-height: ${props.maxHeight};
      opacity: 1;
      overflow: visible;
    `}

  ${props => props.customStyles && props.customStyles}
`;

